import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

export interface UpdateIdentifier {
  identifier?: string;
}

const client = createClient('/rest/operator-api/charging-stations');

export const updateIdentifier: SaveOperation<UpdateIdentifier, void, string> = postRequestFactory<
  UpdateIdentifier,
  void,
  string
>(client, {
  pattern: '/{chargingStationId}/set-custom-identifier',
  permissionId: commandPermissions.SET_CUSTOM_IDENTIFIER
});
